<style scoped>
    @import "./index.css";
</style>

<template>
    <div id="login">
        <div class="login-header"></div>
        <div class="login-content-wrap">
            <div class="login-content">
                <Row type="flex" justify="center">
                    <Col :xs="24">
                        <div class="header-logo">
                            <h3>绑定手机</h3>
                        </div>
                        <Alert show-icon>欢迎使用瀚土智能管理系统</Alert>
                        <Form ref="accountLogin" :model="accountLogin" :rules="accountLoginRule">
                            <FormItem prop="phone">
                                <Input clearable placeholder="请输入手机号" :maxlength="11" icon="ios-person" size="large" type="text" v-model="accountLogin.phone"></Input>
                            </FormItem>
                            <FormItem prop="verify_code" class="yzm">
                                <Input clearable placeholder="请输入验证码" :maxlength="4" size="large" type="text" v-model="accountLogin.verify_code"></Input>
                                <span :class="['yzm-btn',accountLogin.is_code === false ? 'active' : '']" @click="getCode">{{accountLogin.code_name}}</span>
                            </FormItem>
                            <FormItem class="mb5">
                                <Button long size="large" :loading="accountLogin.btnLoading" type="primary" @click="handleSubmit('accountLogin')">
                                    <span>{{!accountLogin.btnLoading ? '绑定' : '绑定中...'}}</span>
                                </Button>
                            </FormItem>
                            <FormItem class="tf-text-right">
                                我有账户? <a href="javascript:;" @click="$func.jumps('login')">立即登录</a>
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
        <div class="login-footer">
            © 1999-2019 瀚土智能 All rights reserved.
        </div>
    </div>
</template>

<script>
    export default {
        name: "regist",
        beforeCreate() {
            //设置背景色
            document.querySelector("body").setAttribute("style", "background:#fbfbfb");
        },
        beforeDestroy() {
            //去除背景色
            document.querySelector("body").setAttribute("style", "");
        },
        created() {
            const that = this;
        },
        data() {
            return {
                // +---------------
                // | 输入框数据
                // +---------------
                accountLogin: {
                    phone: "",
                    verify_code:'',
                    btnLoading: false,

                    //验证码
                    is_code:false,
                    code_name:"获取验证码",
                },

                // +---------------
                // | 验证规则
                // +---------------
                accountLoginRule: {
                    //账号登录
                    phone: [
                        {
                            required: true,
                            message: "请输入正确的手机号",
                            trigger: "change",
                            validator:this.validatePhone
                        }
                    ],
                    verify_code: [
                        {pattern: /^\d{4}$/, required: true, message: "请输入4位数字验证码", trigger: "blur"},
                    ]
                }
            }
        },
        methods: {
            //验证手机
            validatePhone(rule, value, callback){
                const that = this;
                if (value === '') {
                    callback(new Error(rule.message));
                } else {
                    if (!that.$func.checkphone(that.accountLogin.phone)) {
                        callback(new Error(rule.message));
                    }else{
                        that.accountLogin.is_code = true;
                    }
                    callback();
                }
            },
            //获取验证码
            getCode:function()
            {
                const that = this;
                //判断
                if(that.accountLogin.is_code)
                {
                    if(that.$func.checkphone(that.accountLogin.phone))
                    {
                        that.accountLogin.is_code = false;
                        let _time  = 60;
                        //倒计时 并且 不可点击
                        let dsq = setInterval(function(){
                            _time--;
                            if(_time > 0){
                                that.accountLogin.code_name = _time+"秒";
                            }else if(_time == 0){
                                clearInterval(dsq);
                                that.accountLogin.is_code = true;
                                that.accountLogin.code_name = "重新获取验证码";
                            }
                        },1000)
                    }else{
                        that.$func.msg('请输入正确的手机号!')
                    }
                }
            },
            // +---------------
            // | 提交表单
            // +---------------
            handleSubmit(name) {
                const that = this;
                //验证表单
                that.$refs[name].validate(valid => {
                    if (valid)
                    {
                        //按钮状态关闭
                        that[name].btnLoading = false;

                        //存储登录信息
                        that.$func.data.set("userInfo", {"id":1,"username":"admin888","mobile":"18119662779"});

                        that.$func.msg('登录成功')

                        that.$refs[name].resetFields();

                        //跳转
                        that.$func.dsqOut(function() {
                            that.$router.push({
                                name: "index"
                            });
                        },2);

                    }
                });
            }
        }
    };
</script>
